module.exports = __webpack_public_path__ + "static/media/howto_remote.f7bdc3fa.png";